import { render, staticRenderFns } from "./CourseInfoStarRating.vue?vue&type=template&id=d1f4d3a2&scoped=true"
import script from "./CourseInfoStarRating.vue?vue&type=script&lang=js"
export * from "./CourseInfoStarRating.vue?vue&type=script&lang=js"
import style0 from "./CourseInfoStarRating.vue?vue&type=style&index=0&id=d1f4d3a2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1f4d3a2",
  null
  
)

export default component.exports